import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from '../../../services/excel/excel.service';
import { ConcentracionAService } from '../../../services/riesgo-credito/riesgos/concentracion-a.service';
import Swal from 'sweetalert2';
import moment from 'moment';
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import { limits } from '../tablasIds';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { companiesRiesgoCredito, companiesRiesgoCreditoAT } from '../../../shared/catalogos';
import { messages } from '../../funciones/mensajes';

interface Cobertura {
  __typename?: string;
  name: string;
  numero: number;
  saldo: number;
  montoConstituido: number;
}

const ordenarCoberturas = (coberturas: Cobertura[]): Cobertura[] => {

  const normalizar = (texto: string): string => {
    return texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  };

  const obtenerOrdenBanda = (estatus: string): number => {
    const texto = normalizar(estatus);
    if (texto === 'al dia') {
      return 0;
    }

    const rango = texto.match(/^(\d+)\s+a\s+(\d+)$/);
    if (rango) {
      return Number(rango[1]);
    }

    const masDe = texto.match(/^mas\s+de\s+(\d+)$/);

    if (masDe) {
      return Number(masDe[1]);
    }
    return Number.MAX_SAFE_INTEGER;
  };

  return [...coberturas].sort(
    (a, b) =>
      obtenerOrdenBanda(a.name) -
      obtenerOrdenBanda(b.name)
  );
};

@Component({
  selector: 'app-concentracion-a',
  templateUrl: './concentracion-a.component.html',
  styleUrl: './concentracion-a.component.css'
})
export class ConcentracionAComponent implements OnInit {
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
 // Gráfica 1 - Combinada
  public dataGrafica1: any[] = [];
  public labelsGrafica1: string[] = [];
  public ejesYGrafica1: string[] = ['Monto', '%'];
  public tipoGraficaCombinada = typesApex.COMBO;
  public coloresGrafica = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public Filters = FiltersM;

// Gráfica 2 - Histórico
  public dataGrafica2: any[] = [];
  public labelsGrafica2: string[] = [];
  public tipoGrafica2 = typesApex.STACKEDHORIZONTAL;

  public tituloModal = "";
  private datosGrafAll = [];
  public encPar: number = 0;
  public pares = [0];
  public idPlantilla: number = 7;
  private idAdmin: string;
  private idInst;


  // Propiedades para controlar etiquetas
  public etiquetas1 = false; // Para la primera gráfica
  public etiquetas2 = false; // Para la segunda gráfica
  public changeLabel1 = false; // Bandera para forzar cambio en graficador1
  public changeLabel2 = false; // Bandera para forzar cambio en graficador2

  public eje = true;
  public subTitlesH = '';

  private numEvaluaciones = 1;
  public tipo1 = "column";
  public tipo2 = "line";

  public prefix = '';
  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';
  public precicion = 1;
  public aling = '';

  public Periodos = [];
  public perspectivas = [];
  public datos = [];
  private limites = [];
  public totales: any;
  public encabezadoMetrica = 1;
  public encPerspectiva = '';
  public ihh = undefined;
  public min = undefined;
  public max = undefined;
  public parametros = [0,0,0,0,0];
  public txtParametro = '';
  public txtImg = '';
  public edicion = false;
  public dataAll: any;  

  /*Titulos y subtitulos*/
  public subTitles = '';
  /*Filtros*/
  public cadenaEvaluacion = [];

  public verTabla = true;
  @ViewChild('graficador1') graficador1: GraficadorComponent;
  @ViewChild('graficador2') graficador2: GraficadorComponent;
  /** click izquierdo */
  @ViewChild(MatMenuTrigger, {static: true}) matMenuTrigger: MatMenuTrigger;
  menuTopLeftPosition =  {x: '0', y: '0'};
  private inputEdit;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
    private cdr : ChangeDetectorRef,
    private concentracionService: ConcentracionAService
    ) { 
    }

  ngOnInit(){
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoCredito.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoCreditoAT.find( c => c.id === this.idInst );
    if(instAT){
      this.idPlantilla = Number(instAT.idPlantilla);
      this.idPlantilla === 7 ? this.getEvaluacion() : this.getEvaluacionesRiesgos();
      this.encPar = this.pares[0];
    }else{
      setTimeout(() => {
        var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInst).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      },500)
    }
  }

  //consultas
  private async getEvaluacion(){
    try {
      const data = await this.concentracionService.getPeriodosAT(this.idPlantilla);      
      this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
      this.getPerspectivas();
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  private async getEvaluacionesRiesgos(){
    try {
      var data = await this.concentracionService.getPeriodosRiesgos(this.idAdmin);
      data = data.getPeriodsCredits;
      data = data.map(({ period, ...resto}) => ({
        ...resto,
        fechaContable: period
      }));
      this.ordenamientoDataEvaluacion([].concat(data));
      this.getPerspectivas();
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }

  private ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.obtenerDataEvaluacion();
    this.idPlantilla === 7 ? this.getPropiedades() : null;
  }

  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per){
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }

  //actualiza la informacion en base a la metrica 
  public cambioMetrica(metrica){
    if(metrica == 'Saldos'){
      this.encabezadoMetrica = 1;
    }else{
      this.encabezadoMetrica = 2
    }

    const p = this.perspectivas.findIndex(p => p.name === this.encPerspectiva);
    const d = this.perspectivas[p].data.find(m => m.metrica === this.encabezadoMetrica);
    this.datos = d.data;
    this.getTotales(this.datos);
    for (const i of this.datos) {
      i.rango = this.enRango(i);
    }
    this.prepararDatosGrafica1();
    this.prepararDatosGrafica2();
  }

  //actualiza la informacion a perspectiva seleccionada 
  public cambioPerspectiva(nPerspectiva){
    this.encPerspectiva = this.perspectivas[nPerspectiva].name;
    //this.obtenerDataEvaluacion();
    const p = this.perspectivas.findIndex(p => p.name === this.encPerspectiva);
    const d = this.perspectivas[p].data.find(m => m.metrica === this.encabezadoMetrica);
    this.datos = d.data;
    this.getTotales(this.datos);
    for (const i of this.datos) {
      i.rango = this.enRango(i);
    }
    this.prepararDatosGrafica1();
    this.prepararDatosGrafica2();
  }

  /* Obtención de periodos */
  private async obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if( ( this.Periodos[i].series[j].check || (tot>0 && tot<12) ) && ( this.Periodos[i].anio > 2022)){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            idEvaluacion: this.Periodos[i].series[j].id,
            porcentaje: '%',
            pos: this.Periodos[i].series[j].pos,
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes),
            mes: this.Periodos[i].series[j].nmes,
            anio: this.Periodos[i].series[j].an,
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    await this.idPlantilla === 7 ? this.getDatosGrafica() : this.getDatosRiesgosGrafica();
    this.idPlantilla === 7 ? this.getDatos() : this.getDatosRiesgos();
  }

  /* formateo de datos */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }

  //Obtiene las perspectivas de acuerdo al periodo
  public getPerspectivas(){
    switch(this.idPlantilla){
      case 7: 
        this.perspectivas = [
          { name:'Regulación', identifier: 'tipoNormativa', data: [] }, 
          { name:'Género', identifier: 'genero', data: [] },
          { name:'Monto otorgado', identifier: 'bandaMontoOtorgado', data: [] },
          { name:'Plazo otorgado', identifier: 'rangoPlazoOtorgado', data: [] },
          { name:'Producto', identifier: 'producto', data: [] },
          { name:'Garantía', identifier: 'tipoGarantia', data: [] },
          { name:'Sucursal', identifier: 'sucursal', data: [] },
          { name:'Región', identifier: 'region', data: [] },
          { name:'Tipo de persona', identifier: 'tipoPersona', data: [] },
          { name:"Nivel de aprobación", identifier: 'nivelAprobacion', data: [] },
        ];
        break;
      case 12: 
        this.perspectivas = [
          { name:"Tipo de crédito", identifier: 'tipoCredito', data: [] },          
          { name:'Género', identifier: 'genero', data: [] },
          { name:'Monto otorgado', identifier: 'montoOtorgado', data: [] },
          { name:'Plazo otorgado', identifier: 'plazoCredito', data: [] },
          { name:"Nivel de aprobación", identifier: 'nivelAprobacion', data: [] },
          { name:'Garantía', identifier: 'garantia', data: [] },
          { name:'Sucursal', identifier: 'sucursal', data: [] },
          { name:'Sector', identifier: 'sector', data: [] },
          { name:'Zona', identifier: 'zona', data: [] },
          { name:'Producto', identifier: 'producto', data: [] },
          { name:'Categoría de morosidad', identifier: 'categoriaMorosidad', data: [] },
          { name:'Metodología', identifier: 'metodologia', data: [] },
          { name:'Edad', identifier: 'edad', data: [] }, 
          { name:'Tipo de interés', identifier: 'tipoInteres', data: [] }, 
          { name:'Departamento', identifier: 'departamento', data: [] }, 
          { name:'Etnia', identifier: 'etnia', data: [] }, 
          { name:'Estado civil', identifier: 'estadoCivil', data: [] }, 
          { name:'Nivel educativo', identifier: 'nivelEducativo', data: [] }, 
          { name:'Tasa de interés', identifier: 'tasaInteres', data: [] }, 
          { name:'Vinculados', identifier: 'vinculados', data: [] }, 
          { name:'Fuentes de pago', identifier: 'fuentesPago', data: [] }, 
        ];
        break;
      default: this.perspectivas = [];
    }
    
    this.perspectivas.sort( function (a,b) {
      if(a.name > b.name){
        return 1;
      }
      if(a.name < b.name){
        return -1
      }
      return 0;
    });
    this.encPerspectiva = this.perspectivas[0].name;
  }

  //Obtiene los datos de la perspectiva
  public async getDatos(){
    try {
      var data = await this.concentracionService.getInfoPerspectives(this.cadenaEvaluacion[0].periodo);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
    const info = data.creditsResultsByPerspective;
    var v = []
    for(const per of this.perspectivas){
      const ex = info[per.identifier]
      if (ex) {
        var t1 = [], t2 = [];
        var t1T = 0, t2T = 0;
        for (const i of ex){
          if( !i.code.includes(',') ){
            const v1 = i.results['sumatoriaAmortizacionCuota'];
            const v2 = i.results['conteoTotalCreditos'] !== null ? i.results['conteoTotalCreditos']: i.results['conteoTotalCreditosUnicos']

            var m1 = 0;
            var m2 = 0;

            try {
              m1 = i.results.saldoCuentasEnMora.vencidos.totalAmortizacionCuota /*+ i.results.saldoCuentasEnMora.vigentes.totalAmortizacionCuota*/;
              m2 = i.results.saldoCuentasEnMora.vencidos.cuentas /*+ i.results.saldoCuentasEnMora.vigentes.cuentas*/;
            } catch {
              m1 = 0;
              m2 = 0;
            }

            t1T += v1;
            t2T += v2;

            var name = limits.getText(i.description);
            name = `${name.substring(0,1).toUpperCase()}${name.substring(1,name.length).toLowerCase()}`;

            t1.push({
              descripcion: name,
              saldoProm: v1/v2,
              monto: v1,
              porcentaje: 0,
              vencido: m1,
              mora: Number((m1*100/v1).toFixed(2)),
              rango: '',
              ind: limits.getLimit(per.identifier+i.code+'-'+1)
            });
            t2.push({
              descripcion: i.description,
              saldoProm: v1/v2,
              monto: v2,
              vencido: m2,
              mora: Number((m2*100/v2).toFixed(2)),
              porcentaje: 0,
              rango: '',
              ind: limits.getLimit(per.identifier+i.code+'-'+2)
            });
          }
        }
        t1.forEach( i => {
          i.porcentaje = Number((i.monto / t1T * 100).toFixed(1));
        });
        t2.forEach( i => {
          i.porcentaje = Number((i.monto / t2T * 100).toFixed(1));
        });
        
        per.data = [
          {metrica: 1, data: t1},
          {metrica: 2, data: t2},
        ]
      }
    }

    const p = this.perspectivas.findIndex(p => p.name === this.encPerspectiva);
    const d = this.perspectivas[p].data.find(m => m.metrica === this.encabezadoMetrica);
    this.datos = d.data;
    this.getTotales(this.datos);
    for (const i of this.datos) {
      i.rango = this.enRango(i);
    }

    this.prepararDatosGrafica1();
  }

  private async getDatosRiesgos(){
    try {
      const p = {anio: this.cadenaEvaluacion[0].anio, mes: this.cadenaEvaluacion[0].mes};
      var data = await this.concentracionService.getInfoPerspectivesRiesgos(this.idAdmin, p);
      data = data.getSubcalculation;
      for(const pers of this.perspectivas){
        var ordenado = undefined;
        if(pers.identifier === 'categoriaMorosidad'){
          ordenado = ordenarCoberturas(data[pers.identifier])
        }
        const ex = ordenado ?? data[pers.identifier];
        if(!ex) continue;
        var t1 = [], t2 = [];
        var t1T = 0, t2T = 0;
        for(const p of ex){
          const v1 = p.saldo, v2 = p.creditos;
          var m1 = p.saldoMora, m2 = p.creditosMora;
          t1T += v1;
          t2T += v2;

          t1.push({
            descripcion: p.name !== '' ? p.name : 'Sin nombre',
            saldoProm: v1/v2,
            monto: v1,
            porcentaje: 0,
            vencido: m1,
            mora: Number((m1*100/v1).toFixed(2)),
            rango: '',
            ind: p.limits
          });
          t2.push({
            descripcion: p.name !== '' ? p.name : 'Sin nombre',
            saldoProm: v1/v2,
            monto: v2,
            vencido: m2,
            mora: Number((m2*100/v2).toFixed(2)),
            porcentaje: 0,
            rango: '',
            ind: p.limits
          });
        }
        t1.forEach( i => {
          i.porcentaje = Number((i.monto / t1T * 100).toFixed(1));
        });
        t2.forEach( i => {
          i.porcentaje = Number((i.monto / t2T * 100).toFixed(1));
        });
        t1.sort((a, b) => {
          if (a.descripcion === 'Sin nombre') return 1;
          if (b.descripcion === 'Sin nombre') return -1;
          return 0;
        });
        t2.sort((a, b) => {
          if (a.descripcion === 'Sin nombre') return 1;
          if (b.descripcion === 'Sin nombre') return -1;
          return 0;
        });
        pers.data = [
          {metrica: 1, data: t1},
          {metrica: 2, data: t2},
        ]
      }
      const persSelec = this.perspectivas.findIndex(p => p.name === this.encPerspectiva);
      const d = this.perspectivas[persSelec].data.find(m => m.metrica === this.encabezadoMetrica);
      this.datos = d.data;
      this.getTotales(this.datos);
      for (const i of this.datos) {
        i.rango = this.enRango(i);
      }
      this.prepararDatosGrafica1();
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }
  
  private async getDatosGrafica(){
    try {
      var auxFin = [];
      for(const eva of this.cadenaEvaluacion){
        var data = await this.concentracionService.getInfoPerspectives(eva.periodo);

        const info = data.creditsResultsByPerspective;
        

        var g1 = [], g2 = [], aux = [], e = [];
        for(const per of this.perspectivas){
          const ex = info[per.identifier]
          if (ex) {
            for (const i of ex){
              if( !i.code.includes(',') ){
                const v1 = i.results['sumatoriaAmortizacionCuota'];
                const v2 = i.results['conteoTotalCreditos'] !== null ? i.results['conteoTotalCreditos']: i.results['conteoTotalCreditosUnicos']

                g1.push(v1);
                g2.push(v2);
                e.push(i.description);
              }
            }
            const s1 = g1.reduce( (a,b) => a+b,0);
            const s2 = g2.reduce( (a,b) => a+b,0);
            var v1 = [], v2 = [];
            g1.forEach( i => {
              v1.push(Number((i/s1*100).toFixed(1)))
            });
            g2.forEach( i => {
              v2.push(Number((i/s2*100).toFixed(1)))
            });
            
            aux.push({
              perspectiva: per.name,
              e: e,
              m1: v1,
              m2: v2
            })

            g1 = [];
            g2 = [];
            e = [];
          }
        }
        auxFin.push({
          eva: eva.evaluacion,
          data: aux
        });
      }
    } catch (err) {
      messages.errorMessageGraph(err);
    }
    this.datosGrafAll = auxFin;
    this.prepararDatosGrafica2();
  }
  private async getDatosRiesgosGrafica(){
    try{
      var auxFin = [];
      for(const eva of this.cadenaEvaluacion){
        const p = {anio: eva.anio, mes: eva.mes};
        var data = await this.concentracionService.getInfoPerspectivesRiesgos(this.idAdmin, p);
        data = data.getSubcalculation;
        var g1 = [], g2 = [], aux = [], e = [];
        for(const pers of this.perspectivas){
          var ordenado = undefined;
          if(pers.identifier === 'categoriaMorosidad'){
            ordenado = ordenarCoberturas(data[pers.identifier])
          }
          const ex = ordenado ?? data[pers.identifier];
          if(!ex) continue;
          for(const p of ex){
            const v1 = p.saldo??0, v2 = p.creditos??0;
            g1.push(v1);
            g2.push(v2);  
            e.push(p.name)
          }
          
          aux.push({
            perspectiva: pers.name,
            e: e,
            m1: g1,
            m2: g2
          })

          g1 = [];
          g2 = [];
          e = [];
        }
        auxFin.push({
          eva: eva.evaluacion,
          data: aux
        });
      }
    this.datosGrafAll = auxFin;
    this.prepararDatosGrafica2();

    }catch(e){
      messages.errorMessageGraph(e);
    }
  }
  public cambiarTipoGrafica2(horizontal: boolean) {
    this.eje = horizontal;
    this.tipoGrafica2 = horizontal ? typesApex.STACKEDHORIZONTAL : typesApex.STACKED;
    this.prepararDatosGrafica2();
  }

  private prepararDatosGrafica2() {
    if (!this.datosGrafAll || this.datosGrafAll.length === 0) {
      this.dataGrafica2 = [];
      this.labelsGrafica2 = [];
      return;
    }

    // Preparar labels (periodos)
    this.labelsGrafica2 = [];
    const per = this.datosGrafAll[0].data.find(p => p.perspectiva === this.encPerspectiva).e;
    
    let aux = [];
    for (const p of per) {
      aux.push([]);
    }
    
    for (const dat of this.datosGrafAll) {
      const inf = dat.data.find(p => p.perspectiva === this.encPerspectiva);
      for (let l = 0; l < per.length; l++) {
        aux[l].push(inf['m' + this.encabezadoMetrica][l]??0);
      }
      this.labelsGrafica2.push(dat.eva);
    }

    // Preparar subtítulo
    const etiquetas = this.labelsGrafica2;
    this.subTitlesH = etiquetas[etiquetas.length - 1] + ' - ' + etiquetas[0];

    // Preparar data
    this.dataGrafica2 = [];
    for (let i = 0; i < per.length; i++) {
      this.dataGrafica2.push({
        name: per[i] !== '' ? per[i] : 'Sin nombre',
        data: aux[i]
      });
    }
    this.dataGrafica2.sort((a, b) => {
      if (a.descripcion === 'Sin nombre') return 1;
      if (b.descripcion === 'Sin nombre') return -1;
      return 0;
    });
    this.cdr.detectChanges();
  }
  private async getPropiedades(){
    try {
      const data = await this.concentracionService.getPropiedades("6463f46b5a452a0012fa8f38", "2023-01-01");
      
      const aditional = data.creditos_sub_calculos.adicionales;
      let auxLimits = []
      for(const periodos of aditional){
        const fec = moment(periodos.periodo.split('T')[0]).format('DD-MM-YYYY');
        if(JSON.stringify(periodos.propiedades).includes('CRE')){
          auxLimits.push({
            periodo: fec,
            limites: periodos.propiedades,
          });
        }
      }
      this.limites = auxLimits;
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  //get totales
  public getTotales(datos){
    var aux = {
      descripcion: 'Total',
      saldoProm: 0,
      monto: 0,
      vencido: 0,
      porcentaje: 0,
      mora: 0,
      min: '',
      max: '',
      rango: ''
    };

    //Calculo del IHH
    var ihh = 0;
    for(var i = 0; i<datos.length; i++){
      aux.saldoProm += datos[i].saldoProm;
      aux.monto += datos[i].monto;
      aux.vencido += datos[i].vencido;
      aux.porcentaje += datos[i].porcentaje;
      // aux.mora += datos[i].mora;
      ihh += Math.pow(datos[i].porcentaje/100,2);
    }
    aux.porcentaje = Number(aux.porcentaje.toFixed(0));
    aux.saldoProm = aux.saldoProm/datos.length
    aux.mora = Number((aux.vencido*100/aux.monto).toFixed(2))
    this.totales =aux;
    ihh=ihh*10000;
    this.ihh = ihh;

    //Calculo de min y max del IHH
    this.min = (1/datos.length)*10000;
    this.max = this.min*(datos.length*0.65);

    //Calculo de parametros por cooperativa
    // this.parametros[0] = this.min;
    // this.parametros[1] = ((this.max - this.min) / 4) + this.parametros[0];
    // this.parametros[2] = ((this.max - this.min) / 4) + this.parametros[1];
    // this.parametros[3] = ((this.max - this.min) / 4) + this.parametros[2];
    // this.parametros[4] = this.max;
    this.parametros[0] = 1000;
    this.parametros[1] = 2000;
    this.parametros[2] = 3500;
    this.parametros[3] = 5000;
    this.parametros[4] = 5000;

    const cuenta = (1/datos.length)
    const divisor = (1-cuenta)
    const newIhh = (((ihh/10000)-cuenta)/divisor)*10000;

    this.parametroIHH(newIhh);
  }

  //calcular el parametro IHH 
  public parametroIHH(num){
    var txt = '';
    if(num<=this.parametros[0]){
      txt = 'MUY BAJA';
      this.txtImg = 'baja'
    }else if(num>this.parametros[0] && num<=this.parametros[1]){
      txt = 'BAJA'
      this.txtImg = 'mediaBaja'
    }else if(num>this.parametros[1] && num<=this.parametros[2]){
      txt = 'MODERADA'
      this.txtImg = 'media'
    }else if(num>this.parametros[2] && num<=this.parametros[3]){
      txt = 'ALTA'
      this.txtImg = 'mediaAlta'
    }else if(num>this.parametros[3]){
        txt = 'MUY ALTA'
        this.txtImg = 'alta'
    }else{
      txt = 'Sin datos';
      this.txtImg = 'baja';
    }
    this.txtParametro = txt;
  }

  public cambiarTipoGrafica1(tipo1: string, tipo2: string) {
    this.tipo1 = tipo1;
    this.tipo2 = tipo2;
    
    // Mapeo de tipos de ApexCharts a typesApex
    const tipoMap = {
      'bar': 'bar',
      'line': 'line',
      'area': 'area'
    };
    
    const t1 = tipoMap[tipo1] || 'bar';
    const t2 = tipoMap[tipo2] || 'line';
    
    // Determinar el tipo de gráfica
    if (t1 !== t2) {
      this.tipoGraficaCombinada = typesApex.COMBO;
    } else if (t1 === 'bar') {
      this.tipoGraficaCombinada = typesApex.BAR;
    } else if (t1 === 'line') {
      this.tipoGraficaCombinada = typesApex.LINE;
    } else if (t1 === 'area') {
      this.tipoGraficaCombinada = typesApex.AREA;
    }
    
    this.prepararDatosGrafica1();
  }

  private prepararDatosGrafica1() {
    if (!this.datos || this.datos.length === 0) {
      this.dataGrafica1 = [];
      this.labelsGrafica1 = [];
      return;
    }

    // Preparar labels SIN RECORTAR
    this.labelsGrafica1 = [];
    const montos = [];
    const porcentajes = [];

    this.datos.forEach((item) => {
      this.labelsGrafica1.push(item.descripcion); // ✅ Sin recortar
      montos.push(item.monto == null ? 0 : item.monto);
      porcentajes.push(item.porcentaje == null ? 0 : item.porcentaje);
    });

    // Preparar data
    const etiqueta = this.encabezadoMetrica === 1 ? 'Monto' : 'Número de cuentas';
    
    if (this.tipoGraficaCombinada === typesApex.COMBO) {
      this.dataGrafica1 = [
        { name: etiqueta, data: montos, type: this.tipo1 },
        { name: '%', data: porcentajes, type: this.tipo2 }
      ];
      this.ejesYGrafica1 = [etiqueta, '%'];
    } else {
      this.dataGrafica1 = [
        { name: etiqueta, data: montos  },
        { name: '%', data: porcentajes }
      ];
      this.ejesYGrafica1 = [''];
    }
    
    this.cdr.detectChanges();
  }

    //ampliar la grafica 
  public ampliarGraf(graf: string) {
    this.tituloModal = graf;
    document.getElementById("ampliar")!.style.display = "block";
  }

    //Cerrar modal ampliar grafica
  public closeModal(){
    document.getElementById("ampliar")!.style.display = "none";
  }

  //detecta el click fuera del modal y cierra 
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }

  /*Formateo de cantidades recibe el numero a formatear 
  y true para decimales false sin decimales */
  public formatoNum(num, dec){
    //no se requieren decimales 
    if(!dec){
      num = Number(num.toFixed(0));
    }
    
    if (num !== undefined && num !== ''){
      return CommonVariables.formatearMoneda(num, dec, this.miles, this.decimal);
    }
    return '';
  }

  public async actualizarLimite(dat, lim){
    var inputValue = this.idPlantilla === 7 ? this.obtLimit(dat, lim) : dat.ind[lim];
    var introdujo: any, guardo = false;

    let texto = '';
    if(lim === 'min'){
      texto = 'mínimo';
    }else{
      texto = 'máximo';
    }

    introdujo = await Swal.fire({
      title: 'Ingresa el procentaje ' +texto,
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return 'El porcentaje no puede exceder el 100%';
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      this.idPlantilla === 7 ? this.actLimites(dat, lim, introdujo.value) : this.postLimitesRiesgos(dat, lim, introdujo.value);
    }else{
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }

    //guarda el nuevo limite del rango, recibe el nuevo dato y el limite a actualizar (min o max)
  public async actLimites(i, limite, valor){
    let lim = this.obtLimitJson();
    let nuevoPerido = false;
    var periodo = moment(FuncionesMes.escrituraPer(this.subTitles)).format('YYYY-MM-DD'), Json; 
    if(lim !== undefined){
      if(lim.limites[''+i.ind] === undefined){
        let nuevo;
        if(limite === 'min'){
          nuevo = JSON.parse('{"'+i.ind+'": { "limits": { "max": 0, "min": '+valor+'}}}');
        }else{
          nuevo = JSON.parse('{"'+i.ind+'": { "limits": { "max": '+valor+', "min": 0}}}');
        }
        Json = Object.assign(nuevo, lim.limites)
        lim.limites = Json;
      }else{
        let nuevo = JSON.parse(JSON.stringify(lim));
        if(limite === 'min'){
          nuevo.limites[''+i.ind].limits.min = Number(valor);
        }else{
          nuevo.limites[''+i.ind].limits.max = Number(valor);
        }
        Json = nuevo.limites;
        lim.limites = nuevo.limites;
      }
    }else{
      const cop = this.obtLimitJsonCopia();
      let nuevo;
      if(cop !== undefined){
        nuevo = JSON.parse(JSON.stringify(cop));
      }else{
        if(limite === 'min'){
          nuevo = JSON.parse('{"limites": {"'+i.ind+'": { "limits": { "max": 0, "min": '+valor+'}}}}');
        }else{
          nuevo = JSON.parse('{"limites": {"'+i.ind+'": { "limits": { "max": '+valor+', "min": 0}}}}');
        }
      }
      
      if(nuevo.limites[''+i.ind] === undefined){
        let nuevos;
        if(limite === 'min'){
          nuevos = JSON.parse('{"'+i.ind+'": { "limits": { "max": 0, "min": '+valor+'}}}');
        }else{
          nuevos = JSON.parse('{"'+i.ind+'": { "limits": { "max": '+valor+', "min": 0}}}');
        }
        Json = Object.assign(nuevos, nuevo.limites)
      }else{
        let nuevos = JSON.parse(JSON.stringify(nuevo));
        if(limite === 'min'){
          nuevos.limites[''+i.ind].limits.min = Number(valor);
        }else{
          nuevos.limites[''+i.ind].limits.max = Number(valor);
        }
        Json = nuevos.limites;
      }
      nuevoPerido = true;
    }
    
    try {
      await this.concentracionService.setLimites(periodo, Json, "6463f46b5a452a0012fa8f38");
      
      if(nuevoPerido){
        this.limites.push({
          periodo: moment(periodo+'-01', "YYYY-MM-DD").format("DD-MM-YYYY"),
          limites: Json
        });
      }
      messages.succesMessageGraph('swal.swalGuardo');
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  public async postLimitesRiesgos(segmento, limite, valor:number){
    try{
      messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
      const body = {
        min: limite === 'min' ? valor : segmento.ind.min,
        max: limite === 'max' ? valor : segmento.ind.max,
        anio: this.cadenaEvaluacion[0].anio,
        mes: this.cadenaEvaluacion[0].mes,
        idInstitution: this.idAdmin,      
      }
      const p = this.perspectivas.find(p => p.name === this.encPerspectiva).identifier;
      const res = await firstValueFrom(this.concentracionService.postLimitesRiesgos(body, p, segmento.descripcion))
      this.perspectivas.find(p => p.name === this.encPerspectiva).data[0].data.find(d => d.descripcion === segmento.descripcion).ind = {
        min: res.min,
        max: res.max,
      }
      this.perspectivas.find(p => p.name === this.encPerspectiva).data[1].data.find(d => d.descripcion === segmento.descripcion).ind = {
        min: res.min,
        max: res.max,
      }
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(e){
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }
  //obtiene el arreglo de limites del periodo
  public obtLimitJson(){
    for(const p of this.limites){
      const  pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if( moment(p.periodo).isSame(pS) ){
        return p;
      }
    }
    return undefined;
  }
  public obtLimitJsonCopia(){
    let exis = undefined;
    for(const p of this.limites){
      const  pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if( moment(p.periodo).isSameOrBefore(pS) ){
        if(exis === undefined){
          exis = p;
        }else if( moment(exis.periodo).isSameOrBefore(moment(p.periodo)) ){
          exis = p;
        }
      }
    }
    return exis;
  }
  //obtiene el valor del lim ya sea min o max
  public obtLimit(prop, lim, form?){
    let auxLimits = undefined;
    for(const p of this.limites){
      const  pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if( moment(p.periodo).isSameOrBefore(pS)  ){
        auxLimits = p;
        if(auxLimits === undefined){
          auxLimits = p;
        }else if( moment(auxLimits.periodo).isBefore(moment(p.periodo)) ){
          auxLimits = p;
        }
      }
    }
    if(auxLimits !== undefined && auxLimits.limites[''+prop.ind]){
      if(form === undefined){
        return this.formatoNum(auxLimits.limites[''+prop.ind].limits[''+lim], true);
      }else{
        return auxLimits.limites[''+prop.ind].limits[''+lim];
      }
    }else{
      return 0;
    }
    return 0;
  }

  //Evalua si el monto se encuentra en el rango determinado para asignar icono correspondiente
  public enRango(i){
    const max = this.idPlantilla === 7 ? this.obtLimit(i, 'max', '') : i.ind.max;
    const min = this.idPlantilla === 7 ? this.obtLimit(i, 'min', '') : i.ind.min;
    if( min < max){
      if(i.porcentaje > max){
        //el monto sobrepasa el maximo establecido
        return "cancel";
      }else if(i.porcentaje >= min && i.porcentaje <= max){
        //el monto esta en rango 
        return "check_circle";
      }else if(i.porcentaje < min){
        //esta por debajo del rango
        return "cancel";
      }
    }else{
      //limites incongruentes
      return "help";
    }
    return "help";
  }

  //validar ingreso de datos numericos para los limites
  public validaNumeros(event){
    if(event.which < 48 || event.which > 57 || event.which == 46){
      event.preventDefault();
    }
  }

  //Agrega las comas a los datos ingresados
  public formateoLim(i, limite){
    var valor = Number(document.getElementById(limite+''+i)["value"].replace(/,/g,""));
    var aux = this.formatoNum(valor,false);
    document.getElementById(limite+''+i)["value"] = aux;
  }

  //funcion exportar tabla a excel
  public exportarExcel(){
    var titulos = [], encabezado = [], datos = [], totales = [];

    titulos.push("");
    titulos.push("");
    titulos.push(this.translate.instant('credito.concentracion.titulo1Tabla' + this.encabezadoMetrica));
    titulos.push("");
    titulos.push("");
    titulos.push("");
    titulos.push(this.translate.instant('credito.concentracion.titulo3Tabla'));
    titulos.push("");
    titulos.push("");

    for(var i = 1; i < 7; i++){
      if(i == 3){
        encabezado.push(this.translate.instant('credito.concentracion.encabezado' + i + this.encabezadoMetrica));
        encabezado.push("%");
      } else if(i == 4){
        encabezado.push(this.translate.instant('credito.concentracion.encabezado33'));
        encabezado.push(this.translate.instant('credito.concentracion.encabezado34'));
        encabezado.push("%" + this.translate.instant('credito.concentracion.encabezado' + i));
      } else if(i == 5 ){
        encabezado.push("%" + this.translate.instant('credito.concentracion.encabezado' + i));
      } else {
        encabezado.push(this.translate.instant('credito.concentracion.encabezado' + i));
      }
    }

    for(const i of this.datos){
      var aux = [];
      aux.push(i.descripcion);
      aux.push(i.saldoProm);
      aux.push(i.monto);
      aux.push(i.porcentaje/100);
      aux.push(i.vencido);
      aux.push(i.mora/100);
      aux.push(this.obtLimit(i, 'min')/100);
      aux.push(this.obtLimit(i, 'max')/100);
      i.rango = this.enRango(i);
      if(i.rango == "help"){
        aux.push("?");
      } else if(i.rango == "check_circle"){
        aux.push("✓");
      } else if(i.rango == "cancel"){
        aux.push("×");
      }else {
        aux.push("");
      }

      datos.push(aux);
    }

    totales.push("Total");
    totales.push(this.totales.saldoProm);
    totales.push(this.totales.monto);
    totales.push(this.totales.porcentaje/100);
    totales.push(this.totales.vencido);
    totales.push(this.totales.mora/100);
    totales.push("");
    totales.push("");
    totales.push("");

    let tituloHoja = this.translate.instant('credito.concentracion.tituloTabla' + this.encabezadoMetrica) + ' | ' + this.encPerspectiva + " | " + this.escrituraPeriodo(this.subTitles)
    let metrica = this.encabezadoMetrica == 1 ? "Saldos" : "Cuentas";
    this.exportExcel.excelCreditoConcentracion(tituloHoja,titulos,encabezado,datos,totales,metrica+' '+this.encPerspectiva+' '+ this.escrituraPeriodo(this.subTitles));
  }


  //exportar grafica en imagen 
  public exportarGrafica(idContenedor: string, tituloKey: string, perspectiva: string) {
    // Determinar qué gráfica exportar según el id del contenedor
    const grafica = idContenedor === 'conteGrafica' ? 1 : 2;
    const isHistorico = grafica === 2;
    
    const titulos = {
      titulo: this.translate.instant(tituloKey) + ' | ' + perspectiva,
      subtitulo: isHistorico ? this.subTitlesH : this.escrituraPeriodo(this.subTitles),
      nombreArch: 'Concentracion_' + (isHistorico ? 'Historico_' : '') + 'Credito_' + perspectiva
    };
    
    const graficador = grafica === 1 ? this.graficador1 : this.graficador2;
    
    if (graficador) {
      graficador.exportImg(grafica, titulos);
    }
  }
}
